import React from 'react'
import { TableIcon } from '@phosphor-icons/react'
import styles from './Summary.module.scss'

/**
 * Table renderer component.
 * Renders summary data in table format.
 *
 * TODO: Implement full table rendering with AG Grid or similar.
 * For now, this is a placeholder that shows the data exists.
 *
 * @param {Object} props
 * @param {Object} props.data - Summary data for table view
 */
export const SummaryTable = ({ data }) => {
    // TODO: Implement full table view with AG Grid
    // The table view requires integration with the existing table rendering logic
    // from the old Explorer component

    if (!data) {
        return (
            <div className={styles.centerContent}>
                <div className={styles.emptyState}>
                    <TableIcon size={48} className={styles.emptyStateIcon} />
                    <span className={styles.emptyStateText}>No table data available</span>
                </div>
            </div>
        )
    }

    return (
        <div className={styles.centerContent}>
            <div className={styles.emptyState}>
                <TableIcon size={48} className={styles.emptyStateIcon} />
                <span className={styles.emptyStateText}>
                    Table view is being implemented. Data has {data?.series?.length || 0} series.
                </span>
            </div>
        </div>
    )
}
